import { DetailForm } from '@/@diffrag/form/DetailForm'
import { DetailManyToOneTable } from '@/@diffrag/form/DetailManyToOneTable'
import { FormFieldType } from '@/@diffrag/form/fields/type'
import { useApi } from '@/@diffrag/hooks/useApi'
import { useQueryValue } from '@/@diffrag/hooks/useQueryValue'
import { ContentDetailView } from '@/@diffrag/layout/ContentDetailView'
import { ContentView } from '@/@diffrag/layout/ContentView'
import { SimpleTable } from '@/@diffrag/table/SimpleTable'
import { api } from '@/api'
import { toast } from '@/lib/toast'
import { AdminCategoryListData } from 'api'

export default function Categories() {
  const q = useQueryValue('q', undefined)

  const { data, isFetching } = useApi({
    id: 'categoryList',
    fn: api().adminCategory.adminCategoryList,
    // params: {
    //   q,
    // },
  })

  const onSave = async (rows: AdminCategoryListData) => {
    // 중복 이름 체크
    const names = rows.items.map((item) => item.name.trim())
    const duplicates = names.filter(
      (name, index) => names.indexOf(name) !== index,
    )

    if (duplicates.length > 0) {
      toast.error('이미 등록 된 카테고리입니다.')
      return
    }

    const deletedItems = data?.items.filter(
      (item) => !rows.items.some((rowItem) => rowItem.id === item.id),
    )

    if (deletedItems?.length) {
      await Promise.all(
        deletedItems.map((item) =>
          api().adminCategory.adminCategoryDelete(item.id),
        ),
      )
    }

    await Promise.all(
      rows.items.map(async (row) => {
        if (row.id) {
          await api().adminCategory.adminCategoryUpdate(row.id, {
            name: row.name,
            order: row.order,
          })
        } else {
          await api().adminCategory.adminCategoryCreate({
            name: row.name,
            order: row.order,
          })
        }
      }),
    )

    toast.success('카테고리를 저장했습니다.')
  }

  return (
    <ContentDetailView
      title="카테고리 목록"
      data={data}
      onSave={onSave}
      hideSaveToast={() => true}
    >
      <DetailManyToOneTable
        name="items"
        title="카테고리 목록"
        dnd
        getFields={() => [
          {
            label: '카테고리',
            key: 'name',
            type: FormFieldType.STRING,
          },
        ]}
      />
    </ContentDetailView>
  )
}
